import React from 'react';
import { Box } from '@mui/material';
import { List, useDataGrid } from '@refinedev/mui';
import { useUserSearch } from '@/features/researchers/hooks';
import {
  UserSearch,
  NoResultsMessage,
  DataGridWrapper,
} from '@/features/researchers/components';
import { searchContainerStyles } from '@/features/researchers/styles';

/**
 * Users list page component
 */
export const UsersList = () => {
  // Get dataGridProps from useDataGrid
  const { dataGridProps } = useDataGrid();

  // Use the custom hook for search functionality
  const {
    searchParams,
    hasActiveSearch,
    filteredRows,
    handleSearchChange,
    handleClearSearch,
  } = useUserSearch(dataGridProps.rows);

  return (
    <List>
      {/* Search form */}
      <Box sx={searchContainerStyles}>
        <UserSearch
          searchParams={searchParams}
          hasActiveSearch={hasActiveSearch}
          onSearchChange={handleSearchChange}
          onClearSearch={handleClearSearch}
        />
      </Box>

      {/* No results message */}
      <NoResultsMessage show={hasActiveSearch && filteredRows.length === 0} />

      {/* Data grid */}
      <DataGridWrapper rows={filteredRows} dataGridProps={dataGridProps} />
    </List>
  );
};
